<template>
  <v-expansion-panels :key="item.post_id" style="min-width: 300px;">
    <v-expansion-panel>
      <v-expansion-panel-header ref="header">
        {{ item.spot?.alias_id || "" }}
        {{ item.spot?.address || "" }}
        {{ item.spot?.unit || "" }}
        ({{
          item.host
            ? `${item.host.name || ""} ${item.host.last_name || ""}`
            : ""
        }})
      </v-expansion-panel-header>

      <v-expansion-panel-content :style="{ width: headerWidth + 'px' }">
        <div class="table-wrapper">
          <v-data-table
            :headers="headers"
            :items="item.data"
            class="elevation-1"
            dense
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.conductor="{ item }">
              {{ (item.user_car.name || "") + " " + (item.user_car.last_name || "") }}
            </template>
            <template v-slot:item.auto="{ item }">
              {{ item.car.patent || "" }}
            </template>
            <template v-slot:item.estado="{ item }">
              {{ item.status }}
            </template>
            <template v-slot:item.motivo_cancelacion="{ item }">
              {{ item.cancel_reason || "" }}
            </template>
            <template v-slot:item.time_quantity="{ item }">
              {{ item.extra_data?.time_quantity || "" }}
            </template>
            <template v-slot:item.payment_method="{ item }">
              {{ item.extra_data?.payment_method || "" }}
            </template>
            <template v-slot:item.fecha="{ item }">
              {{ formatDateTimeUtc3(item.created_at) }}
            </template>
          </v-data-table>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      headers: [
        { text: "Conductor", value: "conductor", sortable: false, class:'text-no-wrap fonts-700 fonts-s14' },
        { text: "Auto", value: "auto", sortable: false, class:'text-no-wrap fonts-700 fonts-s14' },
        { text: "Estado", value: "estado" , sortable: false, class:'text-no-wrap fonts-700 fonts-s14'},
        { text: "Motivo cancelacion", value: "motivo_cancelacion", sortable: false, class:'text-no-wrap fonts-700 fonts-s14' },
        { text: "Unidad", value: "payment_method", sortable: false, class:'text-no-wrap fonts-700 fonts-s14' },
        { text: "Tiempo", value: "time_quantity", sortable: false, class:'text-no-wrap fonts-700 fonts-s14' },
        { text: "Fecha", value: "fecha", sortable: false, class:'text-no-wrap fonts-700 fonts-s14' },
      ],
      headerWidth: 0,
      resizeObserver: null,
    };
  },
  methods: {
    formatDateTimeUtc3(date) {
      if (!date) return null;

      const d = new Date(date);

      // Convertimos a milisegundos y aplicamos offset UTC-3
      const utcMinus3 = new Date(d.getTime() - 3 * 60 * 60 * 1000);

      const pad = (num) => String(num).padStart(2, '0');

      const day = pad(utcMinus3.getUTCDate());
      const month = pad(utcMinus3.getUTCMonth() + 1);
      const year = utcMinus3.getUTCFullYear();

      const hours = pad(utcMinus3.getUTCHours());
      const minutes = pad(utcMinus3.getUTCMinutes());
      const seconds = pad(utcMinus3.getUTCSeconds());

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const headerEl = this.$refs.header?.$el || this.$refs.header;
      if (!headerEl) return;

      const setWidth = () => {
        this.headerWidth = headerEl.offsetWidth;
      };

      setWidth();

      this.resizeObserver = new ResizeObserver(() => {
        setWidth();
      });

      this.resizeObserver.observe(headerEl);
    });
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
};
</script>

<style scoped>
.table-wrapper {
  overflow-x: auto;
}
</style>
